// Import AWS SDK polyfills first - must be at top before any AWS imports
import './aws-polyfill';

import { Amplify } from 'aws-amplify';
import { createApp } from 'vue';

import App from './App.vue';
import { USER_POOL_SETTINGS } from './config/api';
import { stage } from './config/env';
import { setupPlugins } from './plugins';
// Import styles
import './assets/index.css';
import './assets/scrollbar.css';
// Note: themes.css removed for dynamic loading - default theme included in index.css
import './assets/chart-theme.css';
import 'vue-sonner/style.css';

import router from './router';
import { initializeSentry } from './utils/sentry';
import { setupSessionTracking } from './utils/sentry-analytics';

// IMPORTANT: Configure AWS Amplify before any component is rendered
// that might use Amplify services
function configureAmplify() {
  try {
    const config = USER_POOL_SETTINGS[stage];
    const { userPoolId, userPoolClientId } = config;

    console.log('Configuring AWS Amplify for environment:', {
      stage,
      userPoolId,
      userPoolClientId,
    });

    // Configure Amplify with Cognito
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolId,
          userPoolClientId,
          signUpVerificationMethod: 'code',
          loginWith: {
            email: true,
          },
        },
      },
    });

    console.log('AWS Amplify configured successfully with Cognito User Pool');
    return true;
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : `${error}`;
    console.error('Failed to configure AWS Amplify:', message);
    // Still configure Amplify with empty values to prevent initialization errors
    Amplify.configure({});
    return false;
  }
}

// Configure Amplify immediately before any component rendering
// const amplifyConfigured =
configureAmplify();

async function bootstrap() {
  const app = createApp(App);

  // Initialize Sentry error tracking (disabled for localhost)
  initializeSentry(app, router);

  // Setup session tracking for user behavior analytics
  setupSessionTracking();

  setupPlugins(app);

  app.use(router);
  app.mount('#app');
}

bootstrap().catch(console.error);
